export default {
  baseUrl: "/",
  apiVersion: "v1/",
  apiKey: "52009ff562107968a258b8a91a2ed06cd5271f27",
  fileAbsUrl: "https://client.fhs.kz",
  pre_logout_deadline: 62,
  logout_deadline: 2
};
